'use strict';

angular.module('shop', [
	'ngAnimate',
	'ui.bootstrap',
	'ui.router',
	'theme',
	'shop.templates'
])

// Html 5 Urls
.config(function ($locationProvider) {
	$locationProvider.html5Mode(true);
});
